module.exports = __webpack_public_path__ + "img/validation-light.967c2379.svg";